import { useAppSelector } from "@/shared/lib/redux"
import { selectVacancies, selectVacanciesLoading } from "../../model"
import { Table } from "@/shared/ui/table"
import { ColumnDef } from "@tanstack/react-table"
import { IJobOpening } from "@/shared/api/employment"
import { DropdownButton } from "@/shared/ui/dropdown-button"
import { Loader } from "@/shared/ui/loader"
import { UpdateVacancy } from "../update-vacancy"
import { DeleteVacancy } from "../delete-vacancy"
import { EditVacancyForm } from "../edit-vacancy-form"

export const Vacancies = () => {
    const vacancies = useAppSelector(selectVacancies)
    const vacanciesLoading = useAppSelector(selectVacanciesLoading)

    const columns: ColumnDef<IJobOpening, any>[] = [
        {
            accessorFn: (vacancy) => (
                <div className="text-[13px] text-color-dark font-semibold">
                    {vacancy.name}
                </div>
            ),
            id: 'name',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start">Название</div>,
        },
        {
            accessorFn: (vacancy) => (
                <div className="text-[13px] text-color-dark font-semibold">
                    {vacancy.salary}
                </div>
            ),
            id: 'salary',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start">Зарплатная вилка</div>,
        },
        {
            accessorFn: (vacancy) => (
                <div className="text-[13px] text-color-dark font-semibold max-w-full overflow-hidden text-ellipsis text-nowrap">
                    {vacancy.description}
                </div>
            ),
            id: 'description',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start">Описание</div>,
        },
        {
            accessorFn: (vacancy) => (
                <div className="w-full flex justify-end">
                    <DropdownButton>
                        <EditVacancyForm vacancy={vacancy}/>
                        <UpdateVacancy vacancy={vacancy} />
                        <DeleteVacancy vacancy={vacancy} />
                    </DropdownButton>
                </div>
            ),
            enableSorting: false,
            id: 'actions',
            cell: info => info.getValue(),
            header: () => null,
        },
    ]

    return (
        <div className="p-3 rounded-2xl bg-white screen:rounded-3xl h-full">
            <div className="px-2 pt-3 text-2xl font-mediumttf uppercase">
                Вакансии
            </div>
            {Boolean(vacancies.length) &&
                <div className="max-h-[300px] h-full overflow-auto">
                    <Table columns={columns} data={vacancies} />
                </div>
            }
            {(!Boolean(vacancies.length) && vacanciesLoading) &&
                <div className="py-3 px-2">
                    <Loader />
                </div>
            }
            {(!Boolean(vacancies.length) && !vacanciesLoading) &&
                <div className="py-3 px-2">
                    Нет данных о вакансиях
                </div>
            }
        </div>
    )
}